import React from 'react';
import * as Animatable from 'react-native-animatable';

interface ErrorMessageProps {
  error: string | undefined;
  visible: boolean | '' | undefined;
}

const ErrorMessage = ({ error, visible }: ErrorMessageProps) => {
  if (!visible) return null;
  return (
    <Animatable.Text
      animation="fadeInLeft"
      style={{
        color: '#ef4444',
        fontSize: 12,
        marginBottom: 8,
        paddingHorizontal: 4,
      }}
    >
      {error}
    </Animatable.Text>
  );
};

export default ErrorMessage;
